<template>
  <div class="zip-file-selector">
    <label
      for="zipFileUpload"
      class="button zip-file-button is-text upload-button"
    >
      Click here to choose a zip file
      <input
        id="zipFileUpload"
        type="file"
        style="display: none;"
        accept="application/zip"
        @change="onChanged"
      >
    </label>
    <p class="box-footer">
      You can only upload one zip file at a time.
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    onChanged (event) {
      const files = event.target.files
      if (files.length !== 1) {
        // Error
        return
      }
      if (files[0].type !== 'application/zip') {
        // Error
        return
      }
      this.$emit('fileSelected', new Array(files[0]))
    }
  }
}
</script>

<style scoped lang="scss">
.zip-file-selector {
  padding: 18px;
  border-top: 1px solid $gray-300;

  .button.zip-file-button {
    color: $primary;
    font-size: 12px;
  }

  .box-footer {
    color: $gray-500;
    font-size: 10px;
  }
}
</style>
